import { AffiliateLoginPage } from './affiliate-login.component';
import { connect } from 'react-redux';
import { affiliateLogin } from './../../api/affiliate/affiliateAction';

const mapDispatchToProps = {
    affiliateLogin
};

const mapStateToProps = state => ({
    isLoading: state.affiliatePage.isLoading,
    isAffiliateLoggedIn: state.affiliatePage.isAffiliateLoggedIn,
    loggedAffiliate: state.affiliatePage.loggedAffiliate
});

export const AffiliateLoginContainer = connect(mapStateToProps, mapDispatchToProps)(AffiliateLoginPage);
